document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth <= 749;
  const maxChars = 260;

  if (isMobile) {
    document.querySelectorAll(".rich-text__text p").forEach((paragraph) => {
      const fullText = paragraph.textContent.trim();

      if (fullText.length > maxChars) {
        const visibleText = fullText.slice(0, maxChars);
        const hiddenText = fullText.slice(maxChars);

        paragraph.innerHTML = `
            ${visibleText}<span class="ellipsis">...</span>
            <span class="more-text" style="display: none;">${hiddenText}</span>
            <a href="javascript:void(0)" class="read-more">Read More</a>
          `;

        paragraph
          .querySelector(".read-more")
          .addEventListener("click", function () {
            const moreText = paragraph.querySelector(".more-text");
            const ellipsis = paragraph.querySelector(".ellipsis");
            const link = this;

            if (moreText.style.display === "none") {
              moreText.style.display = "inline";
              ellipsis.style.display = "none";
              link.textContent = "Read Less";
            } else {
              moreText.style.display = "none";
              ellipsis.style.display = "inline";
              link.textContent = "Read More";
            }
          });
      }
    });
  }
});
